import * as React from 'react'

function SvgPlayerPause(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        d="M8 3c1.105 0 2 .84 2 1.875v14.25C10 20.161 9.105 21 8 21s-2-.84-2-1.875V4.875C6 3.839 6.895 3 8 3zm8 0c1.105 0 2 .84 2 1.875v14.25C18 20.161 17.105 21 16 21s-2-.84-2-1.875V4.875C14 3.839 14.895 3 16 3z"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default SvgPlayerPause
